/**
 * Map Generator — Entry Point
 * Routes config to the correct generator.
 */

import type { GridMap, GeneratorConfig } from './types';
import { generateBSPDungeon } from './generators/bsp-dungeon';
import { generateCave } from './generators/cave';
import { generateArena } from './generators/arena';
import { PRESETS } from './generators/presets';
import { generateCity } from './generators/city';

export function generateMap(config: GeneratorConfig): GridMap {
  switch (config.type) {
    case 'bsp_dungeon':
      return generateBSPDungeon(config);
    case 'cave':
      return generateCave(config);
    case 'arena':
      return generateArena(config);
    case 'city':
      return generateCity(config);
    case 'preset':
      return (PRESETS[config.presetName ?? 'pillar_hall'] ?? PRESETS.pillar_hall)();
    default:
      return generateBSPDungeon(config);
  }
}
